//
// Module for the Follow Up tab of the User Workload page
//
rs.module("content/user/workload/contactlogs",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrls) {

            var filter = $.js(jsSelectors.filter);
            var assignedRadioContainer = filter.js(jsSelectors.assignedRadioContainer);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Handle the assigned/unassigned radio changed event
            assignedRadioContainer.find("input").click(function () {

                loadingSpinner.show();

                gridModule.update(

                    backendUrls.getGridData,

                    { assigned: assignedRadioContainer.find("input:checked").val() },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);